function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 8C16 3.58872 12.4113 0 8 0C3.58872 0 0 3.58872 0 8C0 9.43766 0.382673 10.8374 1.10934 12.0663L1.10925 12.0667C1.79695 13.2294 2.77058 14.2031 3.93334 14.8908L3.93366 14.8907C5.16256 15.6173 6.56234 16 8 16C12.4113 16 16 12.4113 16 8ZM6.77238 6.13811H5.54476C5.54476 4.78421 6.6461 3.68286 8 3.68286C9.3539 3.68286 10.4552 4.78421 10.4552 6.13811C10.4552 6.82529 10.1643 7.48577 9.65681 7.94997L8.61381 8.90457V9.86189H7.38619V8.36397L8.828 7.04428C9.08568 6.8085 9.22762 6.48673 9.22762 6.13811C9.22762 5.46116 8.67695 4.91049 8 4.91049C7.32305 4.91049 6.77238 5.46116 6.77238 6.13811ZM8.61381 11.0895V12.3171H7.38619V11.0895H8.61381Z"
});

function SvgPrompt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrompt);
export default __webpack_public_path__ + "static/media/prompt.cde587f1.svg";
export { ForwardRef as ReactComponent };